exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-sub-nav a[data-v-7defb3a4]{cursor:pointer}", ""]);

// exports
